import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { ArticlesSeoService } from '../articles-seo.service';
import { ArticlesService } from '../articles.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit {
  title = '';
  sortField: UntypedFormControl = new UntypedFormControl('publishDate:desc');

  private pageSize = 100;

  searchQuery = '';
  searchSort = this.sortField.value;
  searchCategory = '';

  page: PageEvent = {
    pageIndex: 1,
    pageSize: 24,
    length: 0,
  };

  constructor(
    private articlesService: ArticlesService,
    private route: ActivatedRoute,
    private routes: Router,
    private seoService: ArticlesSeoService,
  ) {}

  get articles$(): Observable<any> {
    return this.articlesService.articles$;
  }
  get page$(): Observable<any> {
    return this.articlesService.articlesHome$;
  }

  ngOnInit(): void {
    this.route.params.subscribe((data) => {
      this.title = data.category || '';
    });

    this.sortField.valueChanges.subscribe((res) => {
      this.searchSort = res;
      this.searchCategory = this.route.snapshot.paramMap.get('category') ?? '';

      this.resetPage();
      this.findArticles();
    });

    combineLatest([
      this.articlesService.onArticleCategoryChanged,
      this.page$,
    ]).subscribe(([articles, page]) => {
      this.seoService.setArticles({ articles, page });
      this.page.length = articles?.meta?.pagination?.total || 24;
      this.page.pageIndex = articles?.meta?.pagination?.page || 1;
    });
  }

  onSearch(query: string): void {
    this.resetPage();
    this.searchCategory = '';
    this.searchQuery = query;

    this.findArticles();

    this.routes.navigate(['./'], {
      queryParams: { s: query, page: 1 },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }

  /*----------------------------------------------------------------------
 | Handle the page event
 |----------------------------------------------------------------------
 | 1. Set the page
 | 2. Find the products
 |----------------------------------------------------------------------
 */
  resetPage() {
    this.page = {
      pageIndex: 1,
      pageSize: 24,
      length: 0,
    };
  }

  handlePageEvent(e: PageEvent) {
    this.page = e;
    this.routes.navigate(['./'], {
      queryParams: { s: this.searchQuery, page: this.page.pageIndex },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
    this.findArticles();
  }

  private findArticles() {
    const category = this.route.snapshot.paramMap.get('category') ?? '';
    this.articlesService
      .getAll(
        'slug',
        this.searchCategory,
        this.page.pageIndex,
        this.page.pageSize,
        this.sortField.value,
        this.searchQuery,
      )
      .subscribe();
  }
}
